import { Extent } from 'ol/extent'

export class DepthProfile {
    public extent:Extent
    public distance:number
    public depths:Array<number>

    constructor({extent = [0,0,0,0] as Extent, distance=0, depths = [] as Array<number>} = {}) {
        this.extent = extent
        this.distance = distance
        this.depths = depths
    }

    static createReadOnlyDepthProfile(data:any) {
       return Object.freeze(new DepthProfile(data));
    }
}